import { Component, ViewEncapsulation } from "@angular/core";
import { Element_ } from "../Element_";
import { HeadlineModel } from "../../../models/elements/HeadlineModel";

@Component({
  selector: "app-headline",
  templateUrl: "./headline.component.html",
  styleUrls: ["./headline.component.scss"],
  encapsulation: ViewEncapsulation.None, // THIS IS IMPORTANT, without you can't style data passed via [innerHTML]
  standalone: false,
})
export class Headline extends Element_ {
  public model: HeadlineModel;

  constructor() {
    super();
    this.model = this.model as HeadlineModel;
  }
}
